<template>
  <div v-if="property">
    <div v-if="!showFullDescription">
      <p class="text-gray-500 line-clamp-[19]" v-html="shortDescription"></p>
      <button
        class="flex items-center justify-center px-2 py-1 mt-5 text-sm font-semibold text-black border border-gray-200 rounded"
        @click="toggleDescription"
      >
        <DropdownIconSvg
          class="stroke-2 ms-0 text-secondary"
          color="secondary"
          height="4"
          width="4"
          :class="{ 'rotate-180': showFullDescription }"
        />
        <span class="pl-1">Read more</span>
      </button>
    </div>
    <div v-else>
      <p class="text-gray-500" v-html="property.description"></p>
      <button
        class="flex items-center justify-center px-2 py-1 mt-5 text-sm font-semibold text-black border border-gray-200 rounded"
        @click="showFullDescription = false"
      >
        <DropdownIconSvg
          class="stroke-2 ms-0 text-secondary"
          color="secondary"
          height="4"
          width="4"
          :class="{ 'rotate-180': shortDescription }"
        />

        <span class="pl-1">Read less</span>
      </button>
    </div>
  </div>
</template>
<script>
import DropdownIconSvg from "@/components/svg/DropDownIconSvg.vue";
export default {
  props: {
    property: Object,
  },
  components: {
    DropdownIconSvg,
  },
  data() {
    return {
      showFullDescription: false,
      shortDescription: "",
      desc: this.property,
    };
  },
  mounted() {
    this.shortDescription = this.desc.description.substring(0, 900);
  },
  methods: {
    toggleDescription() {
      this.showFullDescription = !this.showFullDescription;
    },
  },
};
</script>
<style>
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}
</style>
